import { ApiManager, Sites } from '@pmi/pmi-iqos-shared-react'
import Cart from './api/cart'
import Market from './api/market'
import Qure from './api/qure'

class DcxApiManager extends ApiManager {
  defaultHeaders = {
    'Content-Type': 'application/json'
  }

  errorCodeTranslationMap = {
    qs_01: 'tk_queryParameterTokenMissing'
  }

  constructor(line) {
    super(Sites.zyn, line)
    this.cart = new Cart(this)
    this.market = new Market(this)
    this.qure = new Qure(this)
  }

  getMock = mock => {
    return () => {
      return require(`../mocks/${mock}.json`)
    }
  }
}

export default DcxApiManager
